export default "__VITE_ASSET__50d7e2c6__"